/**
 * Parallax Funktionalität für Slider hinzufügen
 * Anwendung / Beispiel: parallax('.container-mit-bild');
 * Wird genutzt in feature_slider-*-parallax
 * Es wird auch berücksichtigt, dass Elemente über dem Slider (prev siblings) die nicht sticky sind, das verschieben
 * für die Höhe aussetzen.
 *
 * @param containerSelector
 */
function parallaxSlider(containerSelector) {
    parallaxSliderHandler(containerSelector);
    $(window).on('scroll', function () {
        parallaxSliderHandler(containerSelector);
    });
}

function parallaxSliderHandler(containerSelector) {
    var scrollPos = $(this).scrollTop();
    var offset = 0;
    var positionTo = 0;

    $(containerSelector).parents('.slider').prevAll().each(function() {
        if ($(this).is(':visible') && $(this).css('visibility') !== 'hidden' && $(this).css('position') !== 'sticky') {
            offset += $(this).outerHeight();
        }
    });
    if (scrollPos > offset)  {
        positionTo = ((scrollPos - offset) / 2);
    }
    $(containerSelector).css({
        'transform': 'translate3d(0px, ' + positionTo + 'px, 0px)'
    });
    $(containerSelector + ' .caption-wrapper').css({
        'transform': 'translate3d(0px, ' + -1*positionTo + 'px, 0px)'
    });
}